import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M25.86 10.3H11.94L7.22 6.15a.64.64 0 0 0-.7-.1.65.65 0 0 0-.38.59v8.62a.65.65 0 0 0 .65.65.69.69 0 0 0 .43-.16l4.72-4.15h13.92zM7.44 13.82V8.08L10.71 11zM25.64 20.56l-4.91-4.31a.65.65 0 0 0-1.07.49v3.66H6.14v1.3h13.52v3.66A.65.65 0 0 0 20 26a.63.63 0 0 0 .27.06.67.67 0 0 0 .42-.16l4.91-4.31a.64.64 0 0 0 .22-.49.66.66 0 0 0-.18-.54zM21 23.92v-5.74l3.27 2.87z' })
));